import { render } from "./AlertAutomatico.vue?vue&type=template&id=fe4c58c6&ts=true"
import script from "./AlertAutomatico.vue?vue&type=script&lang=ts"
export * from "./AlertAutomatico.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__